import { OZ } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { findValidI18nKey } from 'pricing-pages-lib/utils/languageUtils';
import { useMemo } from 'react';
import { COMMERCE } from 'self-service-api/constants/EnrolledProductLines';
import { FREE } from 'self-service-api/constants/ProductLevels';
import styled from 'styled-components';
import { hasEnrolledFeatureAtAccessLevel } from './CommerceFeatureTableConfig';
import { FeatureAvailableIcon, FeatureUnavailableIcon } from './SharedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
const FeatureAvailableIconWithOutline = () => {
  const outlineStyles = {
    outline: `2px dashed ${OZ}`,
    outlineOffset: '2px'
  };
  return /*#__PURE__*/_jsx(FeatureAvailableIcon, {
    iconProps: {
      style: outlineStyles
    }
  });
};
const IconWrapper = styled.span.attrs({
  tabIndex: -1
}).withConfig({
  displayName: "CommerceFeatureTableCell__IconWrapper",
  componentId: "sc-1fp9h8o-0"
})([""]);
const CommerceFeatureTableCell = ({
  feature,
  accessLevel,
  productLevel,
  isSuite = false
}) => {
  const hasFeature = isSuite && productLevel ? feature.productLevelAvailability.includes(productLevel) : hasEnrolledFeatureAtAccessLevel(feature, accessLevel);
  const shortLimitKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.shortLimits.${COMMERCE}.${accessLevel}`, `enrolledProductLine.features.${feature.shortName}.shortLimits.default.${accessLevel}`]);
  const longLimitKey = findValidI18nKey([`enrolledProductLine.features.${feature.shortName}.longLimits.${COMMERCE}.${accessLevel}`, `enrolledProductLine.features.${feature.shortName}.longLimits.default.${accessLevel}`]);
  const shouldHideCopy = !isSuite && feature.productLevelAvailability.includes(FREE) && accessLevel !== FREE;
  const hasFeatureCheckMark = hasFeature && !shortLimitKey && (Array.isArray(feature.hasCheckMark) ? feature.hasCheckMark.includes(accessLevel) : feature.hasCheckMark);
  const MemoShortLimitContent = useMemo(() => {
    if (!hasFeature) return /*#__PURE__*/_jsx(FeatureUnavailableIcon, {});
    if (hasFeature && !hasFeatureCheckMark && !shortLimitKey || shouldHideCopy) {
      return null;
    }
    return /*#__PURE__*/_jsx(IconWrapper, {
      children: /*#__PURE__*/_jsx(FeatureAvailableIconWithOutline, {})
    });
  }, [hasFeature, hasFeatureCheckMark, shortLimitKey, shouldHideCopy]);
  const tooltipContent = longLimitKey || shortLimitKey || null;
  if (!MemoShortLimitContent) {
    return /*#__PURE__*/_jsx("td", {
      className: "p-x-1"
    });
  }
  return /*#__PURE__*/_jsx("td", {
    className: "p-x-1",
    children: tooltipContent ? /*#__PURE__*/_jsx(UITooltip, {
      use: "longform",
      placement: "left",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: tooltipContent
      }),
      children: MemoShortLimitContent
    }) : MemoShortLimitContent
  });
};
export default CommerceFeatureTableCell;